import { tns } from '../../node_modules/tiny-slider/src/tiny-slider';

$(document).ready(() => {
  if ($('.flavor-carousel-section').length > 0) {
    const slider = tns({
      container: '.flavor-carousel-slider',
      loop: true,
      items: 1,
      autoplay: false,
      controls: false,
      navContainer: '#flavor-carousel-menu',
      navAsThumbnails: true,
      speed: 200,
      autoplayButtonOutput: false,
      responsive: {
        640: {
          items: 1,
          gutter: 20,
        },
      },
    });
  }

  var firstSlideTitle = $('.tns-nav-active').find('h3').text();
  $('#btn-label').text(firstSlideTitle);

  // document.querySelectorAll('.flavor-menu-item').forEach((el) => {
  //   console.log(el);
  // });

  $('.flavor-menu-item').each(function () {
    $(this).on('click', function () {
      var title = $(this).find('h3').text();
      $('#btn-label').text(title);
      $('#sliderNavigation').removeClass('show');
    });
  });

  sidebarCollpaseVisibilityCheck();

  //checks for browser window resizing up to desktop to show hidden collapsed items
  jQuery(window).on('resize', function (e) {
    e.stopPropagation();
    e.preventDefault();
    sidebarCollpaseVisibilityCheck();
  });

  function sidebarCollpaseVisibilityCheck() {
    var sidebarCollapse = document.querySelectorAll(
      '[data-bs-target="#sliderNavigation"]'
    );
    console.log('41', sidebarCollapse.length);
    if (sidebarCollapse.length === 1) {
      var viewportWidth =
        window.innerWidth || document.documentElement.clientWidth;
      if (viewportWidth >= 992) {
        $('#sliderNavigation').removeClass('collapse');
      }
    }
  }
});
